import  '../../css/style.css';
import React from 'react'
import MyTable from '../../components/myTable';
import { useSelector } from 'react-redux';


const SuccessfulTransaction = () => {

  const marginLeft = useSelector(state => state.style.payload.marginLeft);

  return (
    <div className='main'>
        <MyTable page={"Successful Transactions"}/>
      
    </div>
  )
}

export default SuccessfulTransaction
